/* global modUtils */
/**
 * Fetches IP geolocation details from ipinfo.io API and stores them in `window.geolocation.responseCollection`.
 * Uses cookie caching (1440 min expiry) to avoid redundant API calls.
 *
 * **Behavior**:
 * - Returns early if window.geolocation is not available
 * - Checks for cached `ipInfo` cookie first
 * - Fetches from ipinfo.io API if no cache exists
 * - Stores filtered response in `window.geolocation.responseCollection.ipInfo`
 *
 * @returns {Promise<void>} void
 */
export async function getIpInfoGeoDetails() {
	if (!window.geolocation) {
		return;
	}

	let filteredIpInfo = null;
	const cookieName = 'ipInfo';
	const cookieExpirationMinutes = 1440;
	const cookieValue = modUtils.getCookie(cookieName);

	if (cookieValue) {
		try {
			filteredIpInfo = JSON.parse(cookieValue);
		} catch (e) {
			return;
		}
	} else {
		try {
			const response = await fetch('https://api.ipinfo.io/lookup/me?token=d5edbd8aba8c6c');
			if (!response.ok) {
				return;
			}
			const jsonResponse = await response.json();
			if (jsonResponse && Object.keys(jsonResponse).length) {
				filteredIpInfo = {
					city: jsonResponse?.geo?.city || '',
					zip: jsonResponse?.geo?.postal_code || '',
					state: jsonResponse?.geo?.region || ''
				};
				modUtils.setCookie(cookieName, JSON.stringify(filteredIpInfo), cookieExpirationMinutes);
			}
		} catch (error) {
			console.error('Something went wrong!', error);
			return;
		}
	}

	if (filteredIpInfo && window.geolocation.responseCollection && typeof window.geolocation.responseCollection === 'object') {
		window.geolocation.responseCollection.ipInfo = filteredIpInfo;
	}
}
